import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, validateOTP, logout, resetTimout, setSupervisorLoginSuccess } from "./common/FirebaseSupervisor";
import { getQueryVariable, getLoginSupervisorAccessRights } from "../store/action/RemoteActionSupervisor";
import translate from "../i18n/translate";
import { getMultiLanguageMessage } from '../i18n/multiLanguage';
import QRCode from 'qrcode';

const OTPSupervisor = (props) => {
    const [otpText, setOTP] = useState("");
    const [isShowQRCode, setIsShowQRCode] = useState(0);
    const [qr, setQR] = useState("");
    const [token, setToken] = useState("");
    const [adminId, SetAdminID] = useState("");
    const [isForcePasswordChange, setIsForcePasswordChange] = useState(false);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [errorCount, setErrorCount] = useState(0);
    const [user, loading, error] = useAuthState(auth);
    const [language, setLanguage] = useState("");
    const navigate = useNavigate();

    const validate = async () => {
        if (otpText.trim()) {
            setIsButtonClicked(true);
            const isValid = await validateOTP(otpText, token, adminId);
            if (isValid) {
                resetTimout();
                if (isForcePasswordChange) {
                    navigate("/passwordchange?Reset=1");
                } else {
                    setSupervisorLoginSuccess();
                    await getLoginSupervisorAccessRights();
                    navigate("/dashboard");
                }
            } else {
                let nErrorCount = errorCount + 1;
                setErrorCount(nErrorCount);
                alert(getMultiLanguageMessage('msg_Incorrect_OTP', language));
                setIsButtonClicked(false);
                if (nErrorCount >= 3) {
                    logout();
                    navigate("/supervisorlogin");
                }
            }
        }
    };

    const setQRCode = async () => {
        let nIsShowQRCode = localStorage.getItem("showQRCode");
        try {
            if (nIsShowQRCode === "1") {
                setIsShowQRCode(parseInt(nIsShowQRCode));
                let sUrl = localStorage.getItem("authenticationUrl");
                let qr = await QRCode.toDataURL(sUrl);
                setQR(qr);
            }
        } catch (ex) {
            console.log(ex);
        }
    };

    useEffect(() => {
        if (loading) {
            return;
        }
        if (error) {
            alert(error);
        }
        setLanguage(localStorage.getItem("locale"));
        let sToken = localStorage.getItem("supervisortoken");
        let sAdminId = localStorage.getItem("supervisorid");
        if (!sToken || !sAdminId || sToken === "undefined" || sAdminId === "undefined") {
            logout();
            navigate("/supervisorlogin");
        }
        setToken(sToken);
        SetAdminID(sAdminId);
        localStorage.removeItem("supervisortoken");
        localStorage.removeItem("supervisorid");
        setQRCode();

        props.actionToggleNavBar(false);
        props.actionToggleSideBar(false);
        props.actionToggleFooter(false);
    }, [user, loading, error]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        let sRID = getQueryVariable(window.location.search, "RID");
        if (sRID && parseInt(sRID) === 2) {
            setIsForcePasswordChange(false);
        } else if (sRID && parseInt(sRID) === 12) {
            setIsForcePasswordChange(true);
        } else {
            logout();
            navigate("/supervisorlogin");
        }
    }, []);

    return (
        <div className="user-ath-page">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-8  text-center">
                        <div className="user-ath-logo">
                            <a href="#">
                                <img width={200} height={200}
                                    src={require('../assets/images/logo_supervisor.PNG')}
                                    srcSet={require('../assets/images/logo_supervisor.PNG')}
                                    alt="icon"
                                />
                            </a>
                        </div>
                        <div className="user-ath-box">
                            {(isShowQRCode === 1) ?
                                <div className="form-note">
                                    {translate('MFASetup-Message')}
                                    <img src={qr} alt="QR Code" />
                                </div>
                                :
                                <div className="form-note">
                                </div>
                            }
                            <div className="input-item">
                                <TextField id="otp" type={'password'} label={translate('OTP')} className='input-bordered' onChange={(e) => setOTP(e.target.value)} />
                            </div>
                            <div className="gaps" />
                            {isButtonClicked &&
                                <>
                                    <div className="gaps" />
                                    <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                                </>
                            }
                            <div className="d-flex justify-content-between align-items-center">
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => validate()}>{translate('Login')}</Button>
                            </div>

                        </div>
                        <div className="gaps-2x" />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter
})(OTPSupervisor);
